import React, { useEffect, useRef, useState } from 'react';
import * as securityHelper from "../../helper/SecurityHelper";
import axios from "axios";
import iconUpload from "../../images/icon-upload.svg";

export default function RequestReply({ replyData, setRequestReply, setSnackbarTxt }: any) {
  const [fileName, setFileName] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const cntntsRef = useRef<any>();
  const btnRef = useRef<any>();
  const [saving, setSaving] = useState(false);
  const [imgSrc, setImgSrc] = useState('');

  const fn_saveBtn = () => {
    btnRef.current.setAttribute("readonly", "readonly");
    setSaving(true);
  };

  useEffect(() => {
    if (saving) {
      fn_onBtnClick();
    }
  }, [saving]);
  useEffect(() => {
    let imageSrc;
    if (fileRef.current) {
      const afFileList = fileRef.current.files;
      if (afFileList.length > 0) {
        imageSrc = URL.createObjectURL(afFileList[0]);
        setImgSrc(imageSrc);
      }
    }
  }, [fileName])

  const fn_onBtnClick = async () => {

    if (replyData.prcsStatCd === '001' && user.auth === 'SRV') {
      if (!window.confirm('작업중지 승인 하시겠습니까?')) {
        return;
      }
      const rsltCnt = await fn_approveWrkStopRqstData();
      if (rsltCnt > 0) {
        setSnackbarTxt('승인 되었습니다.');
      } else {
        setSnackbarTxt('오류가 발생했습니다. 관리자에게 문의해 주십시오 .');
        btnRef.current.removeAttribute("readonly");
        setSaving(false);
        return;
      }
    } else if (replyData.prcsStatCd === '002' && user.auth === 'COM') {

      const rsltCnt = await fn_actImprvMsr();
      if (!rsltCnt) {
        return;
      }

      if (rsltCnt > 0) {
        setSnackbarTxt('처리 되었습니다.');
      } else {
        setSnackbarTxt('오류가 발생했습니다. 관리자에게 문의해 주십시오 .');
        btnRef.current.removeAttribute("readonly");
        setSaving(false);
        return;
      }
    }
    setRequestReply(false);
  }

  const fn_actImprvMsr = async () => {
    const actCntnts = cntntsRef.current.value;
    const fileList = fileRef.current.files;
    const formData = new FormData();

    if (!actCntnts) {
      setSnackbarTxt('내용을 입력해 주십시오.');
      cntntsRef.current.focus();
      return;
    }

    if (fileList.length > 0) {
      formData.append('multipartFiles', fileList[0]);
    }

    const jsonObject = {
      updtrSeq: user.seq,
      actCntnts: actCntnts,
      wrkStopSeq: replyData.wrkStopSeq
    }

    formData.append('jsonData', JSON.stringify(jsonObject));

    if (!window.confirm('작업을 재개 하시겠습니까?')) {
      return;
    }
    const rtrnData = await axios.post('admin/api/wrkStopRqst/actImprvMsr', formData)

    return rtrnData.data;
  }

  const fn_approveWrkStopRqstData = async () => {
    const rtrnData = await axios.post('admin/api/wrkStopRqst/approveWrkStopRqstData', { updtrSeq: user.seq, wrkStopSeq: replyData.wrkStopSeq });

    return rtrnData.data;
  }

  const user = securityHelper.getLoginUser();

  const fileHandler = () => {
    fileRef.current.click();
  };

  const fn_delete = async (wrkStopSeq: number) => {
    if (!window.confirm('삭제 하시겠습니까?')) {
      return;
    }

    const rtrnData = await axios.post('admin/api/wrkStopRqst/deleteWrkStopRqstData', { wrkStopSeq: wrkStopSeq })
    if (rtrnData.data > 0) {
      setSnackbarTxt('삭제 되었습니다.');
      setRequestReply(false);
    }
  }

  return (
    <div className='h-[calc(100%-52px)] md:h-[calc(100%-130px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center'>
      <div className='w-[265px] sm:w-[318px] md:w-[750px] '>
        <div className='flex justify-between items-center mt-33 md:mt-[82px]'>
          <p className='ml-7 md:ml-[17px] font-preBold text-15 leading-18 md:text-37 md:leading-[45px]'>신고 내용</p>
          {/* 작업중지 상태에서는 뜨지 않게 해놨습니다. 자기가 작성한 글일 경우만 추가하고 삭제 로직 추가하면 됩니다. */}
          {replyData.prcsStatCd === '002' && replyData.rgstrSeq == user.seq ?
            <button
              onClick={() => { fn_delete(replyData.wrkStopSeq) }}
              className='mr-7 md:mr-[17px] w-60 md:w-[150px] h-32 md:h-[80pz] text-white text-14 leading-16 md:text-35 md:leading-[40px] rounded-[5px] md:rounded-[12px] bg-[#585959]'>삭제</button>
            : null}
        </div>
        <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-22 md:mb-[55px]' />
        <div className='flex items-center justify-between'>
          <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>행사명</p>
          <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{replyData.evntNm}</p>
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>장소</p>
          <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{replyData.exbtPlc}</p>
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>신고자</p>
          <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{replyData.rgstrNm}</p>
        </div>
        <div className='flex justify-between mt-16 md:mt-[40px]'>
          <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>내용</p>
          <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{replyData.allCntnts}</p>
        </div>
        <div className={replyData.atchFileId === null ? 'flex justify-between items-center font-preLight text-12 sm:text-14 md:text-35 mt-24 md:mt-[60px]' : 'flex justify-between mt-24 md:mt-[60px]'}>
          <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>첨부사진</p>
          <div className='w-[182px] sm:w-[235px] md:w-[587px]'>
            {replyData.atchFileId === null ? <p>첨부된 사진이 없습니다.</p> : <img src={'admin/api/cmmn/fileDownload?atchFileId=' + replyData.atchFileId + '&fileSn=0'} alt='' className='w-full h-129 md:h-[322px] border boder-[#D9D9D9] rounded-[5px] md:rounded-[12px]' />}
          </div>
        </div>
        {replyData.prcsStatCd == '003' || (replyData.prcsStatCd == '002' && user.auth == 'COM') ?
          <>
            <p className='mt-33 ml-7 md:mt-[82px] md:ml-[17px] font-preBold text-15 leading-18 md:text-37 md:leading-[45px]'>조치내용</p>
            <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-22' />
            <div className='flex items-center justify-between mt-16'>
              <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>조치자</p>
              <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{replyData.actrNm}</p>
            </div>
            {replyData.actTime ?
              <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
                <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>조치일시</p>
                <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{replyData.actTime}</p>
              </div>
              : null
            }

            <div className='flex justify-between mt-16 md:mt-[40px]'>
              <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>내용</p>
              {(replyData.prcsStatCd === '002' && user.auth === 'COM') ?
                <textarea
                  ref={cntntsRef}
                  className='w-[182px] sm:w-[235px] md:w-[587px] h-130 md:h-[325px] px-10 pt-10 md:px-[25px] md:pt-[25px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[40px] outline-none bg-[#F6F6F8] rounded-[5px] md:rounded-[12px] placeholder:text-12 sm:placeholder:text-14 md:placeholder:text-35 placeholder:text-[#9C9C9B] placeholder:leading-16 md:placeholder:leading-[40px] placeholder:font-preLight ' placeholder='내용을 입력해주세요.' />
                : <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{replyData.actCntnts}</p>
              }
            </div>
            <div className={replyData.atchFileId === null ? 'flex justify-between items-center font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[40px]'
              : 'flex justify-between mt-16 md:mt-[40px]'}>
              <p className='ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]'>사진첨부</p>
              <div className='w-[235px] md:w-[587px]'>
                {!(replyData.prcsStatCd === '002' && user.auth === 'COM')
                  ? replyData.actAtchFileId === null ? <p>첨부된 사진이 없습니다.</p>
                    : <img
                      src={'admin/api/cmmn/fileDownload?atchFileId=' + replyData.actAtchFileId + '&fileSn=0'}
                      alt=''
                      className='w-[235px] md:w-[587px] h-129 md:h-[322px] border boder-[#D9D9D9] rounded-[5px] md:rounded-[12px]' />
                  : !fileName
                    ? <button
                      onClick={fileHandler}
                      className='flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                      <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                      <p>파일 올리기</p>
                    </button>
                    :<><img onClick={fileHandler} src={imgSrc} alt='doneImage' className='object-cover border border-[#D9D9D9] md:w-[65px] md:h-[65px]' />
                          <button onClick={fileHandler} className='my-7 md:my-[17px] flex justify-center items-center w-[70%] h-38 md:h-[95px] outline-none border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-gray-400 font-preLight'>
                            <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                            <p>삭제</p>
                          </button></>
                }
              </div>
              <input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />
            </div></> : null
        }
      </div>
      <button
        ref={btnRef}
        onClick={fn_saveBtn}
        className='font-preLight text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] mb-20 md:mb-[50px] py-15 md:py-[37px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-50 md:mt-[125px]'>
        {(replyData.prcsStatCd === '001' && user.auth === 'SRV') ? '작업중지승인' : (replyData.prcsStatCd === '002' && user.auth === 'COM') ? '개선 조치' : '확인'}
      </button>
    </div>
  );
}

